import { CheckIcon, UncheckedBox } from "../../assets/designedPickedIcons";
import { IoCheckbox } from "react-icons/io5";
import { BsCheckSquareFill } from "react-icons/bs";

const LabeledCheckedInput = ({
  label,
  value,
  setValue,
  iconColor,
  iconSize,
  Icon,
}) => {
  return (
    <div
      onClick={() => setValue(!value)}
      className="d-flex align-items-center cursor-pointer "
      style={{ gap: 10 }}
    >
      <div style={{ color: iconColor }}>
        {Icon ? (
          <Icon size={iconSize} checked={value} />
        ) : value ? (
          <CheckIcon size={iconSize} />
        ) : (
          <UncheckedBox size={iconSize} />
        )}
      </div>

      <h6  className="color-primary-black-4 m-0 f-5">{label}</h6>
    </div>
  );
};

export default LabeledCheckedInput;
